import { createContext, useContext } from 'react'
import '../../styles/chart.scss'

const ChartContext = createContext()
export const useDimensionsContext = () => useContext(ChartContext)

const Chart = ({ dimensions, children }) => {
  const isSmall = dimensions.height < 420
  return (
    <ChartContext.Provider value={dimensions}>
      <svg id="main-chart" width={dimensions.width} height={dimensions.height}>
        <g
          className="border"
          transform={`translate(${dimensions.marginLeft}, ${
            isSmall ? 0 : dimensions.marginTop
          })`}
        >
          {children}
        </g>
      </svg>
    </ChartContext.Provider>
  )
}

export default Chart
